import React from 'react';
import { Button } from '@mui/material';
import { ScoutCalendarAction } from '../../../ScoutCalendar/types';
import { InitialScoutCalendarState } from '../../../ScoutCalendar/reducer';

interface CreateEventButtonProps {
  dispatch: React.Dispatch<ScoutCalendarAction>;
  variant?: 'text' | 'outlined' | 'contained';
  sx?: any;
  children?: React.ReactNode;
  createMultiple?: boolean;
  className?: string;
  id?: string;
}

export default function CreateEventButton({
  dispatch,
  variant = 'contained',
  sx,
  children = 'Create event',
  createMultiple = false,
  className,
  id
}: CreateEventButtonProps) {
  const handleCreateEvent = () => {
    dispatch({ type: 'CREATE_MULTIPLE_EVENTS', payload: createMultiple });
    dispatch({
      type: 'SET_CREATE_EVENT_OBJECT',
      payload: {
        ...InitialScoutCalendarState.createEventObject,
        eventDate: new Date(),
        dates: [new Date()],
        step: 1
      }
    });
    dispatch({ type: 'SET_SHOW_CREATE_EVENT_MODAL', payload: true });
    window.history.pushState(null, '', createMultiple ? '?new_multiple' : '?new');
  };

  return (
    <Button variant={variant} sx={sx} onClick={handleCreateEvent} className={className} id={id}>
      {children}
    </Button>
  );
}
